import { Suspense } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { RootState } from '../../setup'
import { ChatSessionsCtxProvider } from '../context/ChatSessionsContext'
import { SelectionProvider } from '../context/ConsistenceSelectionContext'
import ReportsWrapper from '../pages/annual-report/ReportsWrapper'
import AssetsPageWrapper from '../pages/assets/AssetsWrapper'
import ClaimsPageWrapper from '../pages/claims/ClaimsWrapper'
import UsersProfile from '../pages/users/features/UsersProfile'
import UsersPageWrapper from '../pages/users/UsersWrapper'
import { DEFAULT_ROUTE } from './routes.config'

export function PrivateRoutes() {
  const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
  
  return (
    <SelectionProvider>
      <ChatSessionsCtxProvider>
          <Suspense fallback={<FallbackView />}>
            <Switch>
              
              <Route exact path='/profile' component={UsersProfile}/>
              <Route path='/assets' component={AssetsPageWrapper}/>
              <Route path='/claims' component={ClaimsPageWrapper}/>
              <Route path='/users' component={UsersPageWrapper}/>
              <Route path='/reports' component={ReportsWrapper} />
              <Redirect from='/auth' to={DEFAULT_ROUTE} />
              <Route path="*">
                <Redirect to={DEFAULT_ROUTE} />
              </Route>
            </Switch>
          </Suspense>
      </ChatSessionsCtxProvider>
    </SelectionProvider>
  )
}
